var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "app-rating",
        {
          landing: _vm.landing,
          review: _vm.review,
          mobile: _vm.mobile,
          mature: _vm.forMatureUser,
          experiment: _vm.isExperiment
        }
      ]
    },
    [
      _c("span", { staticClass: "b-sprite-paywall-pix-stars-big stars" }),
      _vm._v(" "),
      _c("h3", [
        _vm._v("\n    Over 50,000 5-star reviews"),
        _vm.landing && !_vm.mobile ? _c("br") : _vm._e(),
        _vm._v("\n    on iOS App Store\n    "),
        _vm.showGooglePlay ? _c("br") : _vm._e(),
        _vm._v("and Google Play"),
        _vm.showIncluding ? _c("span", [_vm._v(", including:")]) : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }